import { Form, Formik, useFormikContext } from 'formik';
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { BackButtonX } from '../../components/BackButton';
import { Button } from '../../components/Button';
import { Loader } from '../../components/Loader';
import { NotFound } from '../../components/NotFound';
import { PTInfo } from '../../components/PTElements';
import { SubmitButton } from '../../components/SubmitButton';
import { ensure, notificationChoreType, scheduleTypes, when_Automated, when_OneOff } from '../../constants';
import { EVO } from '../../EVO';
import { withEnsure } from '../../redux/ensure';
import * as actions from "../../redux/notificationchores";
import { urls } from '../../urls';
import { NCDFilter } from './NCDFilter';
import { NcdStep1 } from './NcdStep1';
import { NcdStep2 } from './NcdStep2';
import { NcdStep3 } from './NcdStep3';
import { NcdStep5 } from './NcdStep5';
import { NcdStep6 } from './NcdStep6';
import './NotificationChoreDetails.css';
import { Question } from './Question';
import { NCDSummary } from './Summary';

const recurringSteps = [1, 2, 3, 4, 5, 6, 7];
const oobSteps = [1, 2, 3, 4, 6, 7];

const NCD = props => {
    const [step, setStep] = useState(process.env.NODE_ENV === 'development' ? 1 : 1);
    const [validating, setValidating] = useState(false);
    const [stepsInUse, setStepsInUse] = useState(recurringSteps);

    useEffect(() => {
        let postEnsure = ensure.appointmentCategory + ensure.practitioner + ensure.appointmentModelProperties + ensure.smsCredits + ensure.business + ensure.billableItems + ensure.sexes + ensure.medicalAlerts + ensure.ptProducts;
        if (props.notificationChoreType === notificationChoreType.Email) {
            postEnsure += ensure.cmEmails;
        }

        props.fetchnotificationchores(props);
        props.ensure(postEnsure);
    }, []);

    const save = (values, { setSubmitting }) => {
        if (stepsInUse[step - 1] === 7) {
            if (values.id) {
                props.updateChore(values)
                    .then(x => {
                        setSubmitting(false);
                        if (!x || !x.error) {
                            props.notificationChoreType === notificationChoreType.Email ? props.history.push(urls.router.transactionalchores.index.url) :
                                props.history.push(urls.router.notificationchores.index.url);
                            EVO.success('Success!');
                        }
                    });
            }
            else {
                props.addItem(values)
                    .then(x => {
                        setSubmitting(false);
                        if (!x || !x.error) {
                            props.notificationChoreType === notificationChoreType.Email ? props.history.push(urls.router.transactionalchores.index.url) :
                                props.history.push(urls.router.notificationchores.index.url);
                            EVO.success('Success!');
                        }
                    });
            }
        }
        else {
            setSubmitting(false);
        }
    };

    const Buttons = () => {
        var retVal = [];
        const currStep = stepsInUse[step - 1];
        const { isSubmitting, validateForm, submitForm } = useFormikContext();
        if (currStep > 1) {
            retVal.push(<Button onMouseDown={e => { e.stopPropagation(); e.preventDefault(); setStep(step - 1); }} text="Back" key="prev" />)
        }
        else {
            retVal.push(<span key="blank"></span>);
        }

        retVal.push(currStep === 1 ? <span key="s1"></span> : <span key="desc">Step {step} of {stepsInUse.length}</span>);

        if (currStep < 7) {
            retVal.push(<Button onMouseDown={e => {
                setValidating(true);
                e.preventDefault();
                setTimeout(function delay() {
                    validateForm().then(e => {
                        EVO.isEmptyObject(e) && setStep(step + 1);
                        setValidating(false);
                    });
                }, 10);
            }} text="Next" key="next" />);
        }
        if (currStep === 7) {
            retVal.push(<SubmitButton type="button" onClick={() => submitForm()} disabled={isSubmitting} classNames={{ 'loading': isSubmitting }} text='Finish' key="submit" />);
        }

        return <div className="ncd-buttons">
            <div className="progress-bar">
                <div className="progress-bar-inner" style={{ width: `${(100 * step) / (stepsInUse.length)}%` }}></div>
            </div>{retVal}</div>;
    };

    

    const validate = (values) => {
        const errors = {};
        const currStep = stepsInUse[step - 1];
        const isSms = values.notificationType === notificationChoreType.Sms;
        const isEmail = values.notificationType === notificationChoreType.Email;

        if (currStep === 1) {
            if (!values.name || values.name.length === 0) {
                errors.name = 'Name is required';
            }

            if (!values.scheduleTypeId) {
                errors.scheduleTypeId = 'Notification Type must be selected';
            }
            else {
                // hack..
                if (values.scheduleTypeId === scheduleTypes.OneOff.value) {
                    setStepsInUse(oobSteps);
                }
                else {
                    setStepsInUse(recurringSteps);
                }
            }
        }

        if (currStep === 2) {
            if (values.marketing === null || values.marketing === '') {
                errors.marketing = 'We must know if this is a marketing notification or not';
            }
        }

        if (currStep === 3) {
            // If one-off, and not now, date/time must be supplied
            if (values.scheduleTypeId === scheduleTypes.OneOff.value) {
                if (values.whenOneOffId === when_OneOff.Scheduled.value) {
                    if (!values.whenOneOffDateTime) {
                        errors.whenOneOffDateTime = 'A date and time is required';
                    }
                }
            }
            else if (values.scheduleTypeId === scheduleTypes.Recurring.value) {
                if (!values.whenAutomatedId) {
                    errors.whenAutomatedId = 'You must choose when to send the SMS';
                }
                else if (!values.whenAutomatedMagnitudeValue) {
                    errors.whenAutomatedMagnitudeValue = 'We need a magnitude';
                }
            }
        }

        if (currStep === 4) {
            if (validating) {
                // If one-off, and only some, then we must have a LastAppt/NextAppt
                if (values.scheduleTypeId === scheduleTypes.OneOff.value && EVO.choreHasFilters(values)) {
                    if (!values.oneOffFrom || !values.oneOffTo) {
                        errors.oneOffSomeError = <span>
                            <span>A date range must be applied</span>
                            <PTInfo colour="#e80c4d" info={`This ensures your SMS is only sent to the most relevant patients that have visited within a specific timeframe in the past or are due to visit in the near future`} />
                        </span>;
                    }
                }
                else if (values.scheduleTypeId === scheduleTypes.Recurring.value || isEmail) {
                    if (values.whenAutomatedId === when_Automated.OnCount.value) {
                        if (!EVO.hasValue(values.appointmentCount)) {
                            errors.appointmentCount = 'A number of appointments must be specified';
                        }
                    }

                    if (EVO.isNumber(values.appointmentCount)) {
                        if (!EVO.hasValue(values.appointmentCountEqualityId) || !values.appointmentCountEqualityId) {
                            errors.appointmentCountEqualityId = 'You must choose an equality comparer';
                        }
                    }
                }

                if (values.whenAutomatedId === when_Automated.AfterMedicalAlertAdded.value && !EVO.any(values.medicalAlerts)) {
                    errors.medicalAlerts = 'A medical alert must be specified';
                }
            }
        }

        if (currStep === 5) {
            if (!values.howOftenId) {
                errors.howOftenId = 'You must select how often';
            }
        }

        if (currStep === 6) {
            // messageTemplate
            if (isSms) {
                if (!values.messageTemplate) {
                    errors.messageTemplate = 'Message Template is required';
                }
            }
            else {
                if (!values.cmEmailId) {
                    errors.cmEmailId = 'You must select an email template';
                }
            }
        }
        return errors;
    }

    return (
        <div className="ncd">
            <Loader loading={(props.loading || props.ensureLoading) && props.notificationchore}>
                    <div>
                    <div style={{ position: 'relative' }}>
                        <div className="ncd-back-button">
                            <BackButtonX />
                        </div>
                            <NotFound found={props.notificationchore}>
                            <div>
                                <Formik
                                        initialValues={props.notificationchore}
                                        onSubmit={save}
                                        validate={(values) => validate(values)}
                                        enableReinitialize={false}>
                                    {() => 
                                        <Form>
                                            {useMemo(() => <RenderStep step={stepsInUse[step - 1]} />, [step])}
                                            <Buttons />
                                        </Form>
                                        }
                                    </Formik>
                                </div>
                            </NotFound>
                        </div>
                    </div>
            </Loader>
        </div>
    );
};

const RenderStep = ({ step }) => {
    switch (step) {
        case 1:
            return <NcdStep1 />;
        case 2:
            return <NcdStep2 />;
        case 3:
            return <NcdStep3 />;
        case 4:
            return <NCDFilter />;
        case 5:
            return <NcdStep5 />;
        case 6:
            return <NcdStep6 />;
        case 7:
            return <div>
                <Question>Summary</Question>
                <NCDSummary getQuote={true} />
            </div>;
        default:
            return <NcdStep1 />;
    }
};

const mapStateToProps = ({ notificationchores, ensure }) => ({
    notificationchore: notificationchores.notificationchore,
    loading: notificationchores.loading,
    error: ensure.ensureError,
    appointmentTypes: ensure.appointmentTypes,
    practitioners: ensure.practitioners,
    appointmentCategories: ensure.appointmentCategories,
    appointmentModelProperties: ensure.appointmentModelProperties,
    smsCredit: ensure.smsCredit,
    ensureLoading: ensure.ensureLoading,
    businesses: ensure.businesses,
    cmEmails: ensure.cmEmails
});

export default connect(mapStateToProps, withEnsure(actions))(withRouter(NCD));


// WEBPACK FOOTER //
// ./src/pages/NotificationChore/NotificationChoreDetails.js